<template>
  
    <v-toolbar fixed class="white">
      <v-toolbar-title><img style="width: 20%;cursor:pointer" @click="$router.push('/')" title="Motor Fiscal"  id="logo-image" src="@/assets/images/logo_transparente/Logotipo_5.png" alt="Logo da Empresa(Motor Fiscal)"></v-toolbar-title>
      <v-spacer></v-spacer>

        <v-tooltip bottom>
            <v-btn slot="activator" icon @click.native="$router.push('/login')">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="#fff" d="M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4A4,4 0 0,0 8,8A4,4 0 0,0 12,12A4,4 0 0,0 16,8A4,4 0 0,0 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9A2.1,2.1 0 0,1 14.1,8A2.1,2.1 0 0,1 12,10.1A2.1,2.1 0 0,1 9.9,8A2.1,2.1 0 0,1 12,5.9Z" />
                </svg>
            </v-btn>
          <span>Logar no sistema</span>
        </v-tooltip>
    
    </v-toolbar>
   
</template>

<script>
export default {
  components: {

  },
  data() {
    return {

    };
  }
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/menu/GuestMenu.vue